import React from 'react';
import { useTheme } from '../context/ThemeContext';

interface GlassmorphicContainerProps {
  children: React.ReactNode;
}

export function GlassmorphicContainer({ children }: GlassmorphicContainerProps) {
  const { isDarkMode } = useTheme();
  
  return (
    <div className="relative group">
      {/* Glassmorphic border */}
      <div className={`absolute inset-0 rounded-2xl ${
        isDarkMode 
          ? 'bg-gradient-to-r from-white/10 via-white/5 to-white/10' 
          : 'bg-gradient-to-r from-white/40 via-white/20 to-white/40'
      } backdrop-blur-sm`} />
      
      {/* Content container */}
      <div className={`relative p-[1px] rounded-2xl ${
        isDarkMode 
          ? 'bg-[#252525]/20 backdrop-blur-sm' 
          : 'bg-white/20 backdrop-blur-sm'
      }`}>
        {children}
      </div>
    </div>
  );
}